import React,{Component} from 'react';


import * as ol from 'openlayers';

import API,{BASEURL} from './API';
import MapLocationList from './MapLocationList';

const pointImageUrl = BASEURL + "point.png";
var historyIconFeature = null;
var vectorSource = new ol.source.Vector({features: []});
const markerStyle = new ol.style.Style({
  image: new ol.style.Icon({
    anchor: [0, 0],
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    src: pointImageUrl
  })
});
const historyMarkerStyle = new ol.style.Style({
  image: new ol.style.Circle({
    radius: 6,
    fill: new ol.style.Fill({
      color: '#FFFF00EE',
    }),
    stroke: new ol.style.Stroke({
      color: '#DDDDDD',
      width: 1,
    }),
  })
});


var map;
class MapView extends Component{

  constructor(props){
    super(props);
    this.mapContainer = React.createRef();
    this.state = {location:this.props.location};
    this.centerToOwnLocation = this.centerToOwnLocation.bind(this);
    this.centerToWorkerLocation = this.centerToWorkerLocation.bind(this);
    this.showHistoryLocation = this.showHistoryLocation.bind(this);
 
  }
  centerToWorkerLocation(){
    var point =  this.props.location != undefined ? ol.proj.fromLonLat([parseFloat(this.props.location.location.longitude),parseFloat(this.props.location.location.latitude)]) : undefined;
    if(map && point){
      
      map.getView().setZoom(16);
      map.getView().setCenter(point);

    }
  }

  showHistoryLocation(selectedLocation){
  
    if(selectedLocation != null && selectedLocation != undefined){
      
      this.props.worker.coordinates.forEach(coord => {
        var point2 =   ol.proj.fromLonLat([parseFloat(selectedLocation.longitude),parseFloat(selectedLocation.latitude)]);
        if(historyIconFeature == null){ 
          historyIconFeature = new ol.Feature(new ol.geom.Point(point2));
          historyIconFeature.setStyle(historyMarkerStyle);
          vectorSource.addFeature( historyIconFeature );
        }else{
          try{
          //historyIconFeature.setGeometry(new ol.geom.Point(point2));
          vectorSource.removeFeature( historyIconFeature );
        
          }catch(e){

          }
          historyIconFeature = new ol.Feature(new ol.geom.Point(point2));
          
          historyIconFeature.setStyle(historyMarkerStyle);
          vectorSource.addFeature( historyIconFeature );
        }
        if(map && point2){
          
          map.getView().setCenter(point2);
    
        }
      });

    }
  }
  centerToOwnLocation(){
    if(map && this.state.ownLocation){
      map.getView().setZoom(16);
    map.getView().setCenter(this.state.ownLocation);
   
    }
  }
  componentDidMount(){
    var point =  this.props.location != undefined ? ol.proj.fromLonLat([parseFloat(this.props.location.location.longitude),parseFloat(this.props.location.location.latitude)]) :[0,0];
  
    
    if( isNaN(point[0])) point[0] = 0;

    if( isNaN(point[1])) point[1] = 0;
    let view = new ol.View({
      center: point,
      zoom: 10,
      projection: 'EPSG:3857'
    });
    map =  new ol.Map({
      view: view,
      controls: ol.control.defaults (),
        layers: [
          new ol.layer.Tile({
            source: new ol.source.OSM()
          }),
          new ol.layer.Vector({
            source: vectorSource
          })
        ],
      target: "mapContainer"
    });

    var geolocation = new ol.Geolocation({
      // enableHighAccuracy must be set to true to have the heading value.
      trackingOptions: {
        enableHighAccuracy: true,
      },
      projection: view.getProjection(),
    });
    var accuracyFeature = new ol.Feature();
geolocation.on('change:accuracyGeometry', function () {
  accuracyFeature.setGeometry(geolocation.getAccuracyGeometry());
});

var positionFeature = new ol.Feature();
positionFeature.setStyle(
  new ol.style.Style({
    image: new ol.style.Circle({
      radius: 6,
      fill: new ol.style.Fill({
        color: '#3399CC',
      }),
      stroke: new ol.style.Stroke({
        color: '#fff',
        width: 2,
      }),
    }),
  })
);
var _this = this;
geolocation.on('change:position', function () {
  var coordinates = geolocation.getPosition();
  positionFeature.setGeometry(coordinates ? new ol.geom.Point(coordinates) : null);
  if(coordinates){
    _this.setState({ownLocation:coordinates});
  }
});

  geolocation.setTracking(true);

    var iconFeature = new ol.Feature(new ol.geom.Point(point));
    iconFeature.setStyle(markerStyle);

    

    vectorSource.clear();
  
  

  
    vectorSource.addFeature( iconFeature );
    vectorSource.addFeature( positionFeature );
    vectorSource.addFeature( accuracyFeature );
       
  

  }
  render(){
    var point =  this.props.location != undefined ? ol.proj.fromLonLat([parseFloat(this.props.location.location.longitude),parseFloat(this.props.location.location.latitude)]) :[0,0];
    const sijaintiMessage =   this.props.location != undefined ?  this.props.location.location.latitude + ", " + this.props.location.location.longitude : "";
    const locations = this.props.worker != undefined  && this.props.worker != null ? this.props.worker.coordinates: null;
   
    if(map != undefined){

 
    }


    return (
      <>
      <MapLocationList showMapLocation={this.showHistoryLocation} locations={locations}></MapLocationList>
      <div className="mapHeader alert alert-info">Työntekijän viimeisin sijainti {sijaintiMessage} </div>

      <div id="mapContainer" ref={this.myRef} className="openlayers-map"  height="100%" width="100%"> </div>
   
      <button className="btnToWorkerLocation" onClick={this.centerToWorkerLocation}>
        Työntekijä
    </button>
    <button className="btnToSeekerLocation"  onClick={this.centerToOwnLocation}>
        Oma sijainti
    </button>
    <button className="btnCloseMap" onClick={this.props.changeToEmployeesView}  >
        Palaa
    </button>
    </>
      );
  

  }
}
export default MapView;
